import Vue from 'vue'
import VueI18n from 'vue-i18n'

import defaultLanguage from './lang/en-GB.json'
import { dateTimeFormats } from './dateTimeFormats'

var locale = localStorage.getItem('locale') || 'en-GB'
var message = {}
message[locale] = defaultLanguage

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: locale,
  messages: message,
  dateTimeFormats: dateTimeFormats
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/i18n.js